import React from 'react'
import { useNavigate } from 'react-router-dom'

const PressArticle = (data) => {
  const navigate = useNavigate()
  const goBack = () => {
    navigate(-1)
  }
  return (
    <div className='minHeight100'>
      <div className='hero-section'>
        
      </div>
      <div className='featured-coverage-section'>
        <div className='section-container'>
          <button className='no-style-button' onClick={goBack}>
            <p className='marginBottom2'>← Back</p>
          </button>
          
          <h2>{data.title}</h2>
          <div dangerouslySetInnerHTML={{__html: data.fullText}} />

          <div className='link' style={{justifySelf: 'center'}}>
            <a target="_blank" rel="noopener noreferrer" className='bigger' href={data.originalUrl}>Read More →</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PressArticle